var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as _ from 'lodash';
import * as React from 'react';
import { withRouter } from "react-router-dom";
import Grid from '../../../components/UI/Grid/Grid';
var VariantsList = /** @class */ (function (_super) {
    __extends(VariantsList, _super);
    function VariantsList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.gridHeaders = [
            { name: 'Баркод', key: 'barcode', filter: false, sort: false },
            { name: 'Цена', key: 'price', filter: false, sort: false },
            { name: 'Стара цена', key: 'old_price', filter: false, sort: false },
            { name: 'Option Value', key: 'option_value_name', filter: false, sort: false },
            { name: 'Позиция', key: 'position', filter: false, sort: false },
        ];
        _this.editVariant = function (rowItem) {
            _this.props.edit(_.get(rowItem, 'id', '-1'));
        };
        _this.onPage = function (event) {
            _this.props.getAllVariants(event.page + 1);
        };
        return _this;
    }
    VariantsList.prototype.render = function () {
        var _a = this.props, gridData = _a.gridData, meta = _a.meta;
        return (React.createElement(Grid, { data: gridData, columns: this.gridHeaders, emptyMessage: '', paginator: true, lazy: true, total: _.get(meta, 'total_records', 0), rows: _.get(meta, 'per_page', 0), first: (_.get(meta, 'current_page', 0) - 1) * _.get(meta, 'per_page', 0), onPage: this.onPage, editAction: this.editVariant }));
    };
    return VariantsList;
}(React.Component));
// @ts-ignore
export default withRouter(VariantsList);



//////////////////
// WEBPACK FOOTER
// ./src/components/Variants/VariantsList/VariantsList.tsx
// module id = 508
// module chunks = 0